const CONTAINER_WIDTH = 860;

module.exports = {
  CONTAINER_WIDTH
};
